import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useFormContext } from "react-hook-form";
import { Feather } from "@expo/vector-icons";
import { StackScreenProps } from "@react-navigation/stack";
import Supplier from "../../utilities/data/model/Supplier";
import { useTranslation } from "../../utilities/i18n";

export type SelectSupplierModalScreenProps = StackScreenProps<
  any,
  "SelectSupplierModalScreen"
>;

export const SelectSupplierModalScreen = ({
  navigation,
}: SelectSupplierModalScreenProps) => {
  const { t } = useTranslation("common");
  const database = useDatabase();
  const [suppliers, setSuppliers] = React.useState<Supplier[] | undefined>();
  const { watch, setValue } = useFormContext<{
    supplierId: string;
  }>();
  const { colors } = useThemeProvider();

  const watchedSupplierId = watch("supplierId");

  React.useEffect(() => {
    database
      .get<Supplier>("suppliers")
      .query()
      .fetch()
      .then((l) => setSuppliers(l));
  }, []);

  const handleOnSelect = React.useCallback((supplierId: string) => {
    setValue("supplierId", supplierId, {
      shouldValidate: true,
      shouldDirty: true,
    });
    navigation.goBack();
  }, []);

  const items: FlatActionListItem[] = React.useMemo(() => {
    return (
      suppliers?.map((supplier) => {
        return {
          key: supplier.id,
          title: supplier.name,
          onPress: () => handleOnSelect(supplier.id),
          componentRight: (icon) => {
            return watchedSupplierId == supplier.id ? (
              <Feather name="check" size={24} color={colors.primary} />
            ) : (
              icon
            );
          },
        };
      }) || []
    );
  }, [suppliers, watchedSupplierId, handleOnSelect]);

  return (
    <Page title={t("modal_select_supplier_title")}>
      <FlatActionList items={items} />
    </Page>
  );
};
